<template>
  <div class="container logged-out-content">
    <form class="block form-md" autocomplete="off" name="loginForm" @submit.prevent="login()">
      <header>
        <div class="pull-left">
          <div class="icon">
            <img src="~assets/images/Patient-Icon.png">
          </div>
        </div>
        <div class="col-xs-9">
          <h2>Login</h2>
        </div>
      </header>

      <div class="content text-bold text-center h4">
        Select a product:
      </div>

      <context-selector></context-selector>
      <error-display v-if="error.message">
        <div v-if="error.type === 'ACCOUNT_LOCKED'">
          Your account is locked. Please use the
          <router-link to="ForgotPassword">forgot password</router-link>
          function to reset your account and password.
        </div>
        <div v-else>
          {{error.message}}
        </div>
      </error-display>

      <div v-if="context" class="content">
        <div class="row">
          <!--TODO: Reintroduce Patient Login When Patient Premium Site Is Constructed On Version 2 -->
          <!-- <input-text v-if="context === 'patient'" name="username" label="Cellphone or Email" v-model="credentials.username" :validation="$v.credentials.username"></input-text> -->
          <under-construction-display :appLinks="links" v-if="context === 'patient'"/>
          <input-text v-if="context === 'practice'" name="username" label="Username" v-model="credentials.username" :validation="$v.credentials.username"></input-text>
          <input-text v-if="context === 'academic'" name="username" label="Email address" v-model="credentials.username" :validation="$v.credentials.username"></input-text>
        </div>
        <div class="row">
           <input-password v-if="context !== 'patient'" name="password" label="Password" v-model="credentials.password" :validation="$v.credentials.password"></input-password>
        </div>
      </div>

      <div v-if="context && (context!=='patient')" class="footer">
        <submit-button id="login-submit" :loading="loading">Login</submit-button>

        <div class="clear"></div>

        <div class="margin-top-20">
          <p>Trouble signing in? <router-link to="ForgotPassword">Click here</router-link></p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { required } from 'vuelidate/lib/validators';

  import ContextSelector from 'components/common/ContextSelector';

  import InputText from 'components/common/inputs/InputText';
  import InputPassword from 'components/common/inputs/InputPassword';
  import SubmitButton from 'components/common/buttons/SubmitButton';
  import ErrorDisplay from 'components/common/outputs/ErrorDisplay';
  import UnderConstructionDisplay from 'components/common/outputs/UnderConstructionDisplay';

  export default {
    name: 'login',
    props: ['loginContext'],
    components: {
      ContextSelector,
      InputText,
      InputPassword,
      SubmitButton,
      ErrorDisplay,
      UnderConstructionDisplay,
    },
    data: () => ({
      credentials: {
        username: '',
        password: '',
        inviteCode: null,
      },
      loading: false,
      error: {
        type: '',
        message: '',
      },
      links: {
        andriod: `${process.env.VUE_APP_PATIENT_APP_ANDROID}`,
        apple: `${process.env.VUE_APP_PATIENT_APP_ISO}`,
      },
    }),
    validations: {
      credentials: {
        username: { required },
        password: { required },
      },
    },
    computed: mapState([
      'context',
    ]),
    methods: {
      saveContext(context) {
        this.$cookies.set('login-context', context, Infinity);
      },
      getContext() {
        const items = [
          this.loginContext,
          this.$cookies.get('login-context'),
          this.context,
          'patient'
        ];
        return items.find(item => !!item && item.length > 0);
      },
      async login() {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          try {
            this.loading = true;
            this.saveContext(this.context);
            await this.$api.login(this.credentials);
          } catch (error) {
            let errorType = '';
            let errorMessage = '';
            if (error.response.status === 409 ||
              error.response.status === 400 ||
              error.response.status === 403 ||
              error.response.status === 500) {
              errorMessage = error.response.data.message || error.response.data.errorMessage;
              errorType = error.response.data.status || error.response.data.statusCode;
            }
            if (error.response.status === 401) {
              const accountLocked = await this.$api.isAccountLocked(this.credentials);
              if (accountLocked) {
                errorMessage = this.$api.accountLocked;
                errorType = 'ACCOUNT_LOCKED';
              } else {
                errorMessage = error.response.data.message || this.$api.invalidUsernameOrPassword;
                errorType = '';
              }
            }
            if (error.response.status === 404
              || error.response.status === 503
              || error.response.status === 504) {
              errorMessage = this.$api.communicationError;
            }

            this.error.message = errorMessage;
            this.error.type = errorType;
          } finally {
            this.loading = false;
          }
        }
      },
      async getInvite() {
        if (this.$route.query.inviteCode) {
          try {
            const invite = await this.$api.fetchPracticeInviteData(this.$route.query.inviteCode);

            if (invite.status === 'SENT') {
              this.credentials.inviteCode = invite.inviteCode;
            } else {
              this.error.message = `Invite cannot be accepted, status of invite currently is ${invite.status}`;
            }
          } catch (error) {
            if (error.response) {
              this.error.message = 'Unable to retrieve invite data';
            } else {
              this.error.message = this.$api.communicationError;
            }
          }
        }
      },
    },
    async mounted() {
      const currentContext = this.getContext();
      if (currentContext && (
          currentContext === 'patient' ||
          currentContext === 'practice' ||
          currentContext === 'academic'
        )) {
        this.$store.dispatch('updateContext', {
          context: currentContext,
        });
      } else {
        this.$store.dispatch('updateContext', {
          context: '',
        });
      }
      this.$on('changeContext', function () {
        this.error = {};
      });

      await this.getInvite();
    },
  };

</script>



// WEBPACK FOOTER //
// Login.vue?2275ed11